module.exports = __webpack_public_path__ + "6a56838c74805698975707d56752da3a.svg";